import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23956845"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminStepTour = _resolveComponent("AdminStepTour")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry) => {
      return (_openBlock(), _createBlock(_Teleport, {
        key: entry.id,
        to: entry.header
      }, [
        _createElementVNode("button", {
          class: "subfunction-tour-trigger",
          type: "button",
          onClick: _withModifiers(($event: any) => (_ctx.start(entry)), ["stop"])
        }, "引导教程", 8, _hoisted_1)
      ], 8, ["to"]))
    }), 128)),
    _createVNode(_component_AdminStepTour, {
      active: _ctx.active,
      steps: _ctx.steps,
      label: _ctx.label,
      "show-catalog": false,
      onFinish: _ctx.finish
    }, null, 8, ["active", "steps", "label", "onFinish"])
  ], 64))
}